import { HttpError } from 'src/app/core/http-error';

export class BatchResult {
    constructor(
        public id: number | string,
        public result: boolean,
        public errorMessage: string = null,
        public error: HttpError = null
    ) {}
}
